import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('BRANDS', ['TABLE_BODY', 'SEARCH', 'FORM'])
